import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { OpportunityTypeFilterService } from './opportunity-type-filter.service';
import { OpportunityTypeFilterComponent } from './opportunity-type-filter.component';
import { OpportunityTypeFilterStoreService } from './opportunity-type-filter-store.service';
import { UpdateTypeSelectorComponent } from '../../sales-opportunities/type-selector/update-type-selector/update-type-selector.component';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [OpportunityTypeFilterComponent],
  imports: [
    CommonModule,
    UpdateTypeSelectorComponent,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
  ],
  providers: [OpportunityTypeFilterService, OpportunityTypeFilterStoreService],
})
export class OpportunityTypeFilterModule {}
